import surfaceNodes from 'graphql/surface-node/queries/surface-nodes';
import surfaceHierarchy from 'graphql/surface/queries/surface-hierarchy';

interface UseReFetchSurfaceData {
  reFetchSurfaceDataAndUpdateCache(): Promise<void>;
}

export default function useReFetchSurfaceData(
  surface: string,
): UseReFetchSurfaceData {
  async function reFetchSurfaceDataAndUpdateCache() {
    await Promise.all([
      surfaceNodes(
        { input: { filter: { surface } } },
        { fetchPolicy: 'network-only' },
      ),
      surfaceHierarchy({ input: { surface } }),
    ]);
  }

  return { reFetchSurfaceDataAndUpdateCache };
}
